import React from "react";
import { useLocation } from "react-router-dom";

import Header from "./modules/MICustomer/components/Header.jsx";
import Footer from "./modules/MICustomer/components/Footer.jsx";
import NavBar from "./modules/MICustomer/components/NavBar.jsx";
import Main from "./modules/MICustomer/views/Main.jsx";
import LoadingIndicator from "./components/LoadingIndicator.js";
import AppMessage from "./components/AppMessage.jsx";
import AppTopMessage from "./components/apptopmessage.jsx";
import PopupMessage from "./modules/MICustomer/components/popupMessage.jsx";
function App(props) {
  const location = useLocation();
  const { pathname } = location;
  const pathnameWithoutSymbol = pathname.substring(1);
  return (
    <>
      <div class="wrapper">
        <Header />
        {/* <NavBar /> */}
        {props.children}
        <Footer />
      </div>
      <LoadingIndicator message="Loading, please wait..." />
      <AppMessage />
      <AppTopMessage />
      <PopupMessage />

      {/*   <NavBar />

      <div className="container-fluid ">
        <div className="wrapper">
          <SideNav />

          <div class="content-page">
            <div class="content">
              {/* Start page title *
              <DashboardTitle />

              <div class="row">{props.children}</div>
            </div>

            <div className="container">
              <div className="row"></div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
  */}
      {/* <ReportEngine />
      <WorkFlow />
    
   
      <WorkFlow />
      <BulkPhotoUpload /> */}
    </>
  );
}
export default App;
